import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'barcos'
})
export class BarcosPipe implements PipeTransform {

  transform(value: any, arg: string): any {
  const resultPost = [];
  for (const post of value) {
     if ( arg === '' || arg ==='Choose...') {
      resultPost.push (post);
     } else {
     if (post.barco === arg){
        resultPost.push (post);
      }
    }
  }
  return resultPost;
  }

}
